<template>
	<div class="overall-for-automatic-test-equipment-list">
		<div class="overall-for-automatic-test-equipment-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Automatic Test Equipment  Solution</span>
			</div>


			<div class="list">

				<ul class="tt">
					<li><img :src="solution_image_01" alt="Xhorse"/></li>
					<li><img :src="solution_image_02" alt="Xhorse"/></li>
				</ul>
				<div class="dd">
					<p>
						Xhorse ATE provides a unified and universal system solution for 3C electronic and semiconductor automatic test. System features:</p>

					<ul>
						<li>
							<h3>1.Openness</h3>
							<p>
								Compatible with all popular instrument control bus PXI, VXI, serial and fpib, it can construct any scale system according to different test requirements, ranging from small system with two or three instruments to large system with two or thirty instruments. At the same time, it supports the integration of tooling developed by users according to test requirements, so as to further improve the level of automatic test.</p>
						</li>
						<li>
							<h3>2.Universality</h3>
							<p>The same system can be used to test different types of electronic equipment.</p>
						</li>
						<li>
							<h3>3.Ease of use</h3>
							<p>
								Friendly user interface makes it easy to master whether it is testing, system integration or test program opening.</p>
						</li>
						<li>
							<h3>4.Modularization</h3>
							<p>
								The modular structure design makes the implementation of the system flexible according to the customer application scale. It supports the network version and the stand-alone version. The stand-alone version and the network version test station are fully compatible.　</p>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_ime_07.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_ime_08.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
            };
        }
    }

</script>

<style scoped="">
		.dd > ul > li > p {
			text-align: justify;
			font-family: "Open Sans";
			font-size: 1rem;
			color: #212525;
			letter-spacing: 0;
			line-height: 1.75rem;
		}

		.dd > ul > li > h3 {
			font-family: "Open SB";
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			line-height: 1.75rem;
			text-align: justify;
		}

		.dd > ul > li > h3, .dd > ul > li > p {
			width: 100%;
		}

		.dd > ul > li {
			width: 100%;
			margin-bottom: 2.75rem;
		}

		.dd > ul {
			width: 100%;
			height: 28rem;
		}

		.dd > p {
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			text-align: justify;
			line-height: 1.75rem;
			width: 100%;
			margin-bottom: 1.5rem;
		}

		.dd {
			width: 100%;
			height: 7rem;
			border: none;
		}

		.tt img {
			width: 100%;
			height: 100%;
		}

		.tt > li:nth-child(1) {
			width: 29.75rem;
		}

		.tt > li:nth-child(2) {
			width: calc(100% - 29.75rem - 1.5rem);
			margin-left: 1.5rem;
		}

		.tt > li {
			float: left;
			height: 20rem;
		}

		.tt {
			margin-bottom: 2.75rem;
		}

		.list > ul:nth-child(1) {
			width: 100%;
			height: 20rem;
		}

		.overall-for-automatic-test-equipment-con {
			width: 61.5rem;
			border: none;
			margin-left: 0px;
		}

		.overall-for-automatic-test-equipment-list {
			width: 61.5rem;
			height: 65.3125rem;
			border: none;
		}

		.list {
			width: 54.5rem;
			height: 34.5rem;
			border: none;
			margin-left: 7rem;
		}

		.x-tit-con {
			font-size: 1.5rem;
			color: #3B3A38;
			line-height: 3.25rem;
		}

		.title {
			width: calc(100% - 3.25rem);
			text-align: left;
			margin-left: 3.25rem;
			margin-top: 2.75rem;
			margin-bottom: 2.75rem;
		}

		.x-icon-keys {
			display: inline-block;
			content: url("../../../assets/resource/icons/ico_solutions.png");
			width: 2.75rem;
			height: 2.75rem;
			position: relative;
			top: .625rem;
			margin-right: 1rem;
		}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-overall-for-automatic-test-equipment.vue